import React, { useState } from 'react'
import { triangle } from '../../Images/Icons'

const YieldSection = (props) => {
    // console.log(props.state)
    const [state, setNewState] = useState({
        showPoup: false,
    });
    const totalYield = parseFloat(props.state.EMConsumed.toFixed(2)) + parseFloat(props.state.fed_to_grid.toFixed(2))
    const persenConsumed = (props.state.EMConsumed.toFixed(2) / totalYield) * 100
    const persenFedToGrid = (props.state.fed_to_grid.toFixed(2) / totalYield) * 100
    const formattedpersenConsumed = isNaN(persenConsumed) ? 0 : persenConsumed.toFixed(2);
    const formattedPersenFedToGrid = isNaN(persenFedToGrid) ? 0 : persenFedToGrid.toFixed(2);

    const setState = data => {
        setNewState(prev => ({ ...prev, ...data }))
    }

    const showPopupConsumption = () => {
        setState({ showPoup: true });
        setTimeout(() => {
            setState({ showPoup: false });
        }, 3000);
    }

    const renderDonut = (consumed, fed) => {
        const total = parseFloat(consumed) + parseFloat(fed);
        const consumedPercent = (100 * (parseFloat(consumed) / total));
        const fedPercent = (100 * (parseFloat(fed) / total));

        return (<div className="" style={{  position: 'absolute', top: -14, border: 'none 1px', width: 100, height: 100, background: 'white', borderRadius: '50%' }}>
        <svg width="100%" height="100%" viewBox="0 0 40 40">
            <circle cx="20" cy="20" r="16" fill="transparent" stroke='lightgreen' strokeWidth="3.5" strokeDasharray={`${fedPercent} ${consumedPercent}`} strokeDashoffset="25" strokeLinecap='round'></circle>
            <circle cx="20" cy="20" r="16" fill="transparent" stroke='#00A660' strokeWidth="3.5" strokeDasharray={`${consumedPercent} ${fedPercent}`} strokeDashoffset={(25+(100-fedPercent))} strokeLinecap='round'></circle>
            <g>
                <text y="50%">
                    <tspan x="50%" textAnchor="middle" style={{ fontSize: '0.4em', fill: '#292929', fontWeight: 500 }}>{total.toFixed(2)}</tspan>
                </text>
                <text y="68%">
                    <tspan x="50%" textAnchor="middle" className='donut-subtitle' style={{ fill: '#6a6a6a', fontSize: '0.3em', fontWeight: 500 }}>kWh</tspan>
                </text>
            </g>
        </svg>
    </div>);
    }

    const { showPoup } = state;

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ height: 20, marginTop: 16, display: 'flex', justifyContent: 'end', alignItems: 'center', fontSize: 12, fontWeight: 500, color: '#5E677B' }}>
                Yield 
                {/* <img src="/monitoring/assets/info.png"  onClick={showPopupConsumption}/> */}
                <span onClick={showPopupConsumption} className='fi fi-rr-info' style={{ marginLeft: 4, lineHeight: 0.8, fontSize: 14, cursor: 'pointer' }}></span>
            </div>
            <div style={{ height: 71, marginTop: 6, background: '#F6F8FB', borderRadius: 12, position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#00A660', fontSize: 16, fontWeight: 500 }}>
                        <span>{props.state.EMConsumed.toFixed(2)}</span> <span style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginLeft: 4 }}>kWh</span>
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginTop: -4 }}>
                        Consumed
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500 }}>
                        ({formattedpersenConsumed}%)
                    </div>
                </div>
                <div style={{ flex: 1, height: 71, border: 'none 1px',display: 'flex', justifyContent: 'center', position: 'relative' }}>
                    {renderDonut(props.state.EMConsumed.toFixed(2), props.state.fed_to_grid.toFixed(2))}
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#00A660', fontSize: 16, fontWeight: 500 }}>
                        <span>{props.state.fed_to_grid.toFixed(2)}</span> <span style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginLeft: 4 }}>kWh</span>
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500, marginTop: -4 }}>
                        Fed to grid
                    </div>
                    <div style={{ color: '#79808F', fontSize: 10, fontWeight: 500 }}>
                        ({formattedPersenFedToGrid}%)
                    </div>
                </div>
            </div>
            {/**Tooltip */}
            {showPoup && <>
                <div style={{
                    width: 300, height: 160, position: 'absolute', top: 30, right: -24, background: '#2C313A', borderRadius: 12, zIndex: 1000,
                    fontSize: 12, fontWeight: 400, color: '#FAFAFA', padding: 12
                }}>
                    <p>Consumed:<br />
                        Amount of PV electricity consumed by loads and charged into energy storage devices.</p>

                    <p>Fed to grid:<br />
                        Amount of power fed to the power grid from the plant in a given reporting period.</p>
                </div>
                <div style={{ position: 'absolute', top: 15, right: -12 }}><img src={triangle} alt="" style={{ width: 36, height: 24 }} /></div>
            </>}
        </div>
    )
}

export default YieldSection